import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { RestService } from '../rest.service';
import { ExcelexportService } from '../excelexport.service';
import { Spanish } from 'flatpickr/dist/l10n/es';

@Component({
  selector: 'app-pagosparking',
  templateUrl: './pagosparking.component.html',
  styleUrls: ['./pagosparking.component.scss']
})
export class PagosparkingComponent implements OnInit {

  customers: any[] = [];
  ubicaciones: any[] = [];
  ubicacion = 1;
  // FlatpickrOptions
  fdesde: any = new Date('2019-01-01').toISOString().slice(0, 10);
  fhasta: any = new Date().toISOString().slice(0, 10);

  optionsdt: DataTables.Settings = {};
  triggerdt: Subject<any> = new Subject();

  fdesdeoptions = {
    locale: Spanish,
    onClose: (selectedDates, dateStr, instance) => this.fdesde = dateStr,
    altFormat: 'Y-m-d'
  };

  fhastaoptions = {
    locale: Spanish,
    onClose: (selectedDates, dateStr, instance) => this.fhasta = dateStr,
    altFormat: 'Y-m-d'
  };

  constructor(public rest: RestService, private excel: ExcelexportService) {
    this.getUbicaciones();
  }

  ngOnInit() {
    this.optionsdt = {
      pagingType: 'full_numbers',
      pageLength: 15,
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_',
        info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        }
      },
      responsive: true,
      scrollX: true,
      autoWidth: false
    };
    this.getCustomers();
  }

  ngOnDestroy() {
    if (!!this.triggerdt) this.triggerdt.unsubscribe();
  }

  getCustomers() {
    this.rest.getCustomersParking(this.fdesde, this.fhasta,this.ubicacion).subscribe((data) => {
      this.customers = data['data'];
      this.triggerdt.next();
    });
  }

  getUbicaciones(){
    this.rest.getUbicaciones().subscribe( (data) => {
      console.log(data);
      this.ubicaciones = data['data'];
    });
  }

  exportAsXLSX(): void {
    this.excel.export2DT(this.customers, 'Clientes Parking');
  }

  getReAPI() {

    const destroy = new Promise(
      (resolve) => {
        this.triggerdt.unsubscribe();
        resolve();
      }
    );

    this.rest.getCustomersParking(this.fdesde, this.fhasta,this.ubicacion).subscribe((data) => {

        destroy.then((then) => {

          if (data['data'].length > 0) {
            this.customers = data['data'];
            this.triggerdt.next();
          }

        })

    });


  }



}
